import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="scent" routeLang="es" />;

export const Route = createFileRoute("/aroma-para-tu-local")({
  head: () => publicToolHead("scent", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
